(function () {
    'use strict';

    angular.module("imApp").factory("stockCountDataItemService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 945,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 946,
                    parameters: edit
                });
            },
            deleteItem: function (edit) {
                return $ihttp.post({
                    method: 957,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
